export default {
  en: { translation: require('../../static/locales/en.json') },
  es: { translation: require('../../static/locales/es.json') },
  id: { translation: require('../../static/locales/id.json') },
  th: { translation: require('../../static/locales/th.json') },
  vi: { translation: require('../../static/locales/vi.json') }
};